<template>
    <section class="ifr__warning ifr__warning--score">
        <div class="-ui-container">
            <h3 v-html="$t('warnings.score.title')"></h3>
            <div class="ifr__warnings-score">
                <span class="ifr__warnings-score-total">{{ score }}</span> / {{ questions.length }}
            </div>
            <p v-html="$t('warnings.score.resume')" :class="['no-warnings is--active']"></p>
            <ul class="ifr__warnings-ctas">
                <li>
                    <button class="ifr__question-btn ifr__question-btn--all" @click="allWarnings">
                        <span>{{ $t('warnings.score.ctas.all') }}</span>
                        <span>{{ $t('warnings.score.ctas.all') }}</span>
                    </button>
                </li>
                <li>
                    <button class="ifr__question-btn ifr__question-btn--replay" @click="replayTest">
                        <span>{{ $t('warnings.score.ctas.replay') }}</span>
                        <span>{{ $t('warnings.score.ctas.replay') }}</span>
                    </button>
                </li>
            </ul>
            <h5 v-html="$t('warnings.intro.h1')"></h5>
            <ul class="ifr__warnings-ssmm">
                <li class="ifr__warnings-ssmm--fb">
                    <a :href='"https://www.facebook.com/sharer/sharer.php?u=https://www.paho.org/hablemos-sobre-demencia/signos-de-advertencia/"' target="_blank">
                        <svg width="50px" height="90px" viewBox="0 0 50 90" >
                            <path d="M50,15.6465 L35.717,15.6465 C34.029,15.6465 32.143,17.8675 32.143,20.8385 L32.143,31.1535 L50,31.1535 L50,45.8535 L32.143,45.8535 L32.143,90.0005 L15.285,90.0005 L15.285,45.8535 L0,45.8535 L0,31.1535 L15.285,31.1535 L15.285,22.5005 C15.285,10.0925 23.896,0.0005 35.717,0.0005 L50,0.0005 L50,15.6465 Z" id="Fill-1"></path>
                        </svg>
                    </a>
                </li>
                <li class="ifr__warnings-ssmm--tw">
                    <a :href='"https://twitter.com/intent/tweet?url=https%3A%2F%2Fwww.paho.org%2Fhablemos-sobre-demencia%2Fsignos-de-advertencia%2F&via=opsoms&text=Hablemos%20sobre%20demencia%3A%20signos%20de%20advertencia&hashtags=hablemos%2Cdemencia"' target="_blank">
                        <svg width="92px" height="15px" viewBox="0 0 92 75">
                            <path d="M92,8.8497 C88.613,10.3517 84.977,11.3657 81.158,11.8227 C85.057,9.4867 88.049,5.7867 89.459,1.3797 C85.811,3.5417 81.771,5.1137 77.473,5.9597 C74.029,2.2907 69.123,-0.0003 63.695,-0.0003 C53.271,-0.0003 44.82,8.4507 44.82,18.8737 C44.82,20.3537 44.986,21.7937 45.309,23.1747 C29.623,22.3887 15.711,14.8737 6.404,3.4537 C4.779,6.2427 3.848,9.4847 3.848,12.9437 C3.848,19.4917 7.18,25.2677 12.244,28.6537 C9.152,28.5557 6.24,27.7077 3.695,26.2937 C3.693,26.3717 3.693,26.4507 3.693,26.5307 C3.693,35.6757 10.201,43.3047 18.834,45.0377 C17.252,45.4697 15.584,45.7017 13.861,45.7017 C12.646,45.7017 11.465,45.5827 10.311,45.3627 C12.713,52.8607 19.686,58.3187 27.943,58.4697 C21.482,63.5337 13.346,66.5507 4.502,66.5507 C2.979,66.5507 1.477,66.4607 0,66.2847 C8.352,71.6417 18.271,74.7677 28.934,74.7677 C63.65,74.7677 82.637,46.0047 82.637,21.0617 C82.637,20.2457 82.619,19.4307 82.582,18.6197 C86.27,15.9597 89.469,12.6357 92,8.8497" id="Fill-1"></path>
                        </svg>
                    </a>
                </li>
            </ul>
        </div>
        <div :class="['ifr__warnings-full', { 'is--active': warningsFull }]">
            <button class="ifr__warnings-full-close" @click="closeAllWarnings"><span>x</span></button>
            <div class="-ui-container">
                <div class="ifr__slider" data-flickity='{ "cellAlign": "left", "contain": true }'>
                    <div class="ifr__slide"><p v-html="$t('warnings.score.warnings.1')"></p></div>
                    <div class="ifr__slide"><p v-html="$t('warnings.score.warnings.2')"></p></div>
                    <div class="ifr__slide"><p v-html="$t('warnings.score.warnings.3')"></p></div>
                    <div class="ifr__slide"><p v-html="$t('warnings.score.warnings.4')"></p></div>
                    <div class="ifr__slide"><p v-html="$t('warnings.score.warnings.5')"></p></div>
                    <div class="ifr__slide"><p v-html="$t('warnings.score.warnings.6')"></p></div>
                    <div class="ifr__slide"><p v-html="$t('warnings.score.warnings.7')"></p></div>
                    <div class="ifr__slide"><p v-html="$t('warnings.score.warnings.8')"></p></div>
                    <div class="ifr__slide"><p v-html="$t('warnings.score.warnings.9')"></p></div>
                    <div class="ifr__slide"><p v-html="$t('warnings.score.warnings.10')"></p></div>
                </div>
            </div>
            
        </div>
    </section>
</template>
<script>
import flickity from 'flickity'
export default {
    name: 'warnings-score',
    data() {
        return {
            warningsFull: false
        }
    },
    computed: {
        questions() {
            return this.$store.state.warnings
        },
        score() {
            return this.$store.state.score
        }
    },
    methods: {
        allWarnings() {
            this.warningsFull = true
            /*
            var warnings = document.querySelectorAll('.ifr__warnings-full p'),
            warningsTl = new TimelineMax()
            warningsTl
            .add('warningsTl')
            .staggerFromTo(warnings, .2, { opacity: 0, x: -50 }, { opacity: 1, x: 0 }, .2, 'warningsTl')
            */
        },
        closeAllWarnings() {
            this.warningsFull = false
        },
        replayTest() {
            fullpage_api.moveTo(1)
            this.$store.commit('replayTest')
        }
    }
}
</script>

